var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPreprod)?_c('div',{staticClass:"ribbon ribbon-top-left"},[_c('span',{staticClass:"text-environement"},[_vm._v("PREPROD")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }